import { mapGetters } from 'vuex'

import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, proxy, request } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showFileManager: false,
      query: this.$route.query
    }
  },

  computed: {
    ...mapGetters({ file: 'file/file' }),

    validation() {
      if (!this.proxy.title) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },
    file: {
      handler(file) {
        this.showFileManager = false
        this.import(file.id)
      },
      deep: true
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  methods: {
    async import(key) {
      try {
        await request.create(
          joinURLPath(Services.keywords, 'import'),
          {
            body: {
              ListId: this.$route.params.id,
              FileId: key
            }
          }
        )
      } catch (error) {
        globalErrorHandler(error)
      }
    }
  },

  render
}
